// extracted by mini-css-extract-plugin
export var closed = "_bh-1";
export var resizer = "_bh-0";